<template>
  <div id="app">
    <home-header></home-header>
    <router-view></router-view>
    <home-footer></home-footer>
  </div>
</template>

<script>
import HomeHeader from './components/Header'
// import HomeHeader from './components/HeaderCopy'
import HomeFooter from './components/Footer'
export default {
  name: 'App',
  components:{
    HomeHeader,
    HomeFooter
  }
}
</script>

<style>
#id{
  width: 1440rem;
  margin: 0 auto;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue


// WEBPACK FOOTER //
// src/App.vue